import $api from "../http";

export default class OilFillingService {
    /** Получить следующий заказ в очередь розлива (200 {order} | 204 без тела). */
    static async getNext() {
        const res = await $api.get('/oil-filling/next');
        return res;
    }

    /** Получить детали заказа розлива по id. */
    static async getById(id) {
        const res = await $api.get(`/oil-filling/${id}`);
        return res.data;
    }

    /** Печать наряда розлива: возвращает { pdfBase64, pagesCount, positionsCount }. */
    static async print(id) {
        const res = await $api.post(`/oil-filling/${id}/print`);
        return res.data;
    }

    /** Завершить розлив: возвращает { ok, orderId, newStatus, alreadyCompleted? }. */
    static async complete(id) {
        const res = await $api.post(`/oil-filling/${id}/complete`);
        return res.data;
    }

    /** Отправить на корректировку с указанием причины. */
    static async correction(id, reason) {
        const res = await $api.post(`/oil-filling/${id}/correction`, { reason });
        return res.data;
    }
}
